import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62ef37ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-contacto container-fluid" }
const _hoisted_2 = { class: "contacto row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "rotulocontacto p-5 mt-5 mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center text-white" }, "CONTACTO", -1))
const _hoisted_6 = { class: "form-floating col-sm m-2 p-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-center" }, "Nombre", -1))
const _hoisted_8 = { class: "form-floating col-sm m-2 p-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-center" }, "Teléfono", -1))
const _hoisted_10 = { class: "form-floating col-sm m-2 p-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-center" }, "Correo Electrónico", -1))
const _hoisted_12 = { class: "form-floating col-sm m-2 p-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-center" }, "Mensaje", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cabecera = _resolveComponent("cabecera")!
  const _component_pie = _resolveComponent("pie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cabecera),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("form", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nombre) = $event)),
                type: "text",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.nombre]
              ]),
              _hoisted_7
            ]),
            _createElementVNode("form", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telefono) = $event)),
                type: "text",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.telefono]
              ]),
              _hoisted_9
            ]),
            _createElementVNode("form", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.correo) = $event)),
                type: "text",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.correo]
              ]),
              _hoisted_11
            ]),
            _createElementVNode("form", _hoisted_12, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mensaje) = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.mensaje]
              ]),
              _hoisted_13
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
              class: "form-floating col-sm m-2 mt-4 p-0"
            }, [
              _createElementVNode("input", {
                type: "submit",
                class: "btn btn-naranja fs-6",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.enviar && _ctx.enviar(...args)), ["prevent"])),
                value: "CONTACTAR"
              })
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(_component_pie)
  ], 64))
}